import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Login from './views/Login.vue'
import Activate from './views/Activate.vue'
import ResetPassword from './views/ResetPassword.vue'
import Benefits from './views/Benefits.vue'
import HouseholdShopper from './views/HouseholdShopper.vue'
import Equity from './views/Equity.vue'
import EquityPaymentResult from './views/EquityPaymentResult.vue'
import Patronage from './views/Patronage.vue'
import CommunityDiscount from './views/CommunityDiscount.vue'
import MemberVolunteer from './views/MemberVolunteer.vue'
import Calendar from './views/Calendar.vue'
import ViewAccount from './views/ViewAccount.vue'
import EditAccount from './views/EditAccount.vue'
import GeneralManager from './views/GeneralManager.vue'
import MemberEngagement from './views/MemberEngagement.vue'

Vue.use(Router)

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: 'home',
            component: Home
        },
        {
            path: '/login',
            name: 'login',
            component: Login
        },
        {
            path: '/about',
            name: 'about',
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            component: function () { 
                return import(/* webpackChunkName: "about" */ './views/About.vue')
            }
        },

        {
            path: '/activate',
            name: 'activate',
            component: Activate,
        },
        {
            path: '/reset-password',
            name: 'reset_password',
            component: ResetPassword,
        },
        {
            path: '/benefits',
            name: 'benefits',
            component: Benefits,
        },
        {
            path: '/household-shopper',
            name: 'household_shopper',
            component: HouseholdShopper,
        },
        {
            path: '/equity',
            name: 'equity',
            component: Equity,
        },
        {
            path: '/equity/payment-success',
            name: 'equity.payment_success',
            component: EquityPaymentResult,
            props: {resultType: 'success'},
        },
        {
            path: '/equity/payment-cancel',
            name: 'equity.payment_cancel',
            component: EquityPaymentResult,
            props: {resultType: 'cancel'},
        },
        {
            path: '/patronage',
            name: 'patronage',
            component: Patronage,
        },
        {
            path: '/community-discount',
            name: 'community_discount',
            component: CommunityDiscount,
        },
        {
            path: '/member-volunteer',
            name: 'member_volunteer',
            component: MemberVolunteer,
        },
        {
            path: '/calendar',
            name: 'calendar',
            component: Calendar,
        },
        {
            path: '/account',
            name: 'view_account',
            component: ViewAccount,
        },
        {
            path: '/update-info',
            name: 'edit_account',
            component: EditAccount,
        },
        {
            path: '/general-manager',
            name: 'general_manager',
            component: GeneralManager,
        },
        {
            path: '/general-manager/ends-report',
            name: 'general_manager.ends_report',
            component: GeneralManager,
            props: {messageType: 'ends-report'},
        },
        {
            path: '/member-engagement',
            name: 'member_engagement',
            component: MemberEngagement,
        },
        {
            path: '/member-engagement/member-engagement',
            name: 'member_engagement.member_engagement',
            component: MemberEngagement,
            props: {messageType: 'member-engagement'},
        },
        {
            path: '/member-engagement/member-quarterly',
            name: 'member_engagement.member_quarterly',
            component: MemberEngagement,
            props: {messageType: 'member-quarterly'},
        },

    ],
    scrollBehavior (to, from, savedPosition) {
        // always scroll to top of new page when navigating
        return {x: 0, y: 0}
    },
})
